const p2p = (function(){
  const POLLING_INTERVAL = 1000;
  const PING_INTERVAL = 5000;
  const PEER_CHECK_TIMEOUT = 30000;
  const CONNECTION_TIMEOUT = 300000;

  var config = {
    lambdaUrl: "",
    turnSecretKey: "",
    iceServers: [
      {urls: "stun:stun.l.google.com:19302"}
    ]
  };

  var pc = null;
  var dataChannel = null;
  var roomId = "";
  var role = "";
  var onErrorCb = function(){};
  var onMessageCb = function(){};
  var onDisconnectedCb = function(){};
  var onConnectedCb = function(){};
  var pollInterval = null;
  var connectionTimeout = null;
  var remoteDescSet = false;
  var iceQueue = [];
  var lastMessageReceived = Date.now();
  var peerCheckInterval = null;
  var pingInterval = null;
  var disconnected = false;

  function log(message) {
    console.log("[P2P] " + message);
  }

  function sendToServer(message) {
    message.role = role;
    log("서버로 메시지 전송: " + JSON.stringify(message));
    return fetch(config.lambdaUrl, {
      method: "POST",
      headers: {"Content-Type": "application/json"},
      body: JSON.stringify(message)
    }).then(function(response){
      return response.json();
    }).then(function(data) {
      return data;
    }).catch(function(error) {
      log("서버 요청 오류: " + error);
      onErrorCb(error);
    });
  }

  function processIceQueue() {
    const errorCallback = onErrorCb;
    while (iceQueue.length > 0 && remoteDescSet) {
      var candidate = iceQueue.shift();
      log("큐에서 ICE 후보 처리");
      pc.addIceCandidate(candidate).catch(function(error) {
        log("ICE 후보 추가 실패: " + error);
        errorCallback(error);
      });
    }
  }

  async function processMessage(msg) {
    try {
      log("처리할 메시지 타입: " + msg.type + ", 현재 역할: " + role + ", remoteDescSet: " + remoteDescSet);
      if (msg.type === "offer" && role === "answerer") {
        log("Offer 수신 - 처리 시작");
        await pc.setRemoteDescription(new RTCSessionDescription({
          type: "offer",
          sdp: msg.sdp
        }));
        log("Remote Description 설정 완료");
        remoteDescSet = true;
        processIceQueue();
        log("Answer 생성 중");
        const answer = await pc.createAnswer();
        log("로컬 Description 설정 중");
        await pc.setLocalDescription(answer);
        log("Answer 전송");
        await sendToServer({
          action: "answer",
          room_id: roomId,
          sdp: pc.localDescription.sdp,
          role: role
        });
        log("Answer 처리 완료");
      }
      if (msg.type === "answer" && role === "offerer") {
        if (pc.signalingState === 'stable') {
          log("Answer 무시 - 이미 stable 상태");
          return;
        }
        log("Answer 수신 - 처리 시작");
        await pc.setRemoteDescription(new RTCSessionDescription({
          type: "answer",
          sdp: msg.sdp
        }));
        log("Remote Description 설정 완료");
        remoteDescSet = true;
        processIceQueue();
      }
      if (msg.type === "ice") {
        log("ICE candidate 수신");
        const candidate = new RTCIceCandidate({
          candidate: msg.candidate.candidate,
          sdpMid: msg.candidate.sdpMid,
          sdpMLineIndex: msg.candidate.sdpMLineIndex,
          usernameFragment: msg.candidate.usernameFragment
        });
        if (remoteDescSet) {
          log("ICE candidate 즉시 추가");
          await pc.addIceCandidate(candidate);
          log("ICE candidate 추가 완료");
        } else {
          log("ICE candidate 큐에 저장 (Remote Description 아직 미설정)");
          iceQueue.push(candidate);
        }
      }
    } catch (error) {
      log("메시지 처리 중 오류 발생: " + error);
      onErrorCb(error);
    }
  }

  function setupDataChannel(channel) {
    channel.onopen = function() {
      log("데이터 채널 열림");
      clearTimeout(connectionTimeout);
      disconnected = false;
      onConnectedCb();
      sendToServer({ action: "complete", room_id: roomId, role: role });
      channel.send(new TextEncoder().encode(JSON.stringify({ type: "ready", timestamp: Date.now() })));
      if (pollInterval) {
        log("P2P 연결 완료 - 폴링 중지");
        clearInterval(pollInterval);
        pollInterval = null;
      }
      lastMessageReceived = Date.now();
      pingInterval = setInterval(function(){
        if(dataChannel && dataChannel.readyState === "open"){
          log("핑 전송");
          dataChannel.send("ping");
        }
      }, PING_INTERVAL);
      peerCheckInterval = setInterval(function(){
        if(Date.now() - lastMessageReceived > PEER_CHECK_TIMEOUT && !disconnected){
          log("상대방의 핑 수신이 30초 이상 없어 연결 종료");
          disconnected = true;
          if(peerCheckInterval){
            clearInterval(peerCheckInterval);
            peerCheckInterval = null;
          }
          if(pingInterval){
            clearInterval(pingInterval);
            pingInterval = null;
          }
          onErrorCb(new Error("Peer inactive"));
          onDisconnectedCb();
          Close();
        }
      }, POLLING_INTERVAL);
    };
    channel.onclose = function() {
      log("데이터 채널 닫힘");
      if(!disconnected) {
        disconnected = true;
        if(peerCheckInterval){
          clearInterval(peerCheckInterval);
          peerCheckInterval = null;
        }
        if(pingInterval){
          clearInterval(pingInterval);
          pingInterval = null;
        }
        Close();
      }
    };
    channel.onerror = function(error) {
      log("데이터 채널 오류: " + error);
      onErrorCb(error);
    };
    channel.onmessage = function(event) {
      var messageText = "";
      if(event.data instanceof ArrayBuffer){
        messageText = new TextDecoder().decode(new Uint8Array(event.data));
      } else {
        messageText = event.data.toString();
      }
      if(messageText === "ping"){
        log("핑 메시지 수신");
        lastMessageReceived = Date.now();
        return;
      }
      lastMessageReceived = Date.now();
      log("메시지 수신: " + messageText);
      onMessageCb(new TextEncoder().encode(messageText));
    };
  }

  function startPolling() {
    if (pollInterval) {
      clearInterval(pollInterval);
    }
    log("폴링 시작");
    const errorCallback = onErrorCb;
    const currentPc = pc;
    const currentRoomId = roomId;
    const currentRole = role;
    pollInterval = setInterval(async function() {
      try {
        if (currentPc.connectionState === 'connected' || currentPc.connectionState === 'failed') {
          log("연결 상태 " + currentPc.connectionState + " - 폴링 중지");
          clearInterval(pollInterval);
          pollInterval = null;
          return;
        }
        const data = await sendToServer({
          action: "poll",
          room_id: currentRoomId,
          role: currentRole
        });
        if (data && data.messages && data.messages.length > 0) {
          log("수신된 메시지 개수: " + data.messages.length);
          const sortedMessages = data.messages.filter(msg => !msg.processed).sort((a, b) => {
            const order = { offer: 0, answer: 1, ice: 2 };
            return order[a.type] - order[b.type];
          });
          for (const msg of sortedMessages) {
            await processMessage(msg);
          }
        }
      } catch (error) {
        log("폴링 중 오류 발생: " + error);
        errorCallback(error);
      }
    }, POLLING_INTERVAL);
  }

  async function generateTurnCredential(secretKey, username) {
    const timestamp = Math.floor(Date.now() / 1000) + 3600; // 1시간 유효
    const user = `${timestamp}:${username || "p2p-client"}`;

    const encoder = new TextEncoder();
    const keyData = encoder.encode(secretKey);
    const userData = encoder.encode(user);

    const key = await crypto.subtle.importKey(
        "raw", keyData, { name: "HMAC", hash: { name: "SHA-1" } }, false, ["sign"]
    );
    const signature = await crypto.subtle.sign("HMAC", key, userData);
    
    const credential = btoa(String.fromCharCode(...new Uint8Array(signature)));
    return { username: user, credential };
  }

  async function setupIceServers() {
    if (!config.turnSecretKey) {
      return [{ urls: "stun:stun.l.google.com:19302" }];
    }

    const credentials = await generateTurnCredential(config.turnSecretKey);
    return [
        { urls: "stun:stun.l.google.com:19302" },
        {
            urls: [
                "turn:turn.tools.camp:3478?transport=udp",
                "turn:turn.tools.camp:3478?transport=tcp",
                "turns:turn.tools.camp:5349"
            ],
            username: credentials.username,
            credential: credentials.credential
        }
    ];
  }

  async function Open(id) {
    if (!config.lambdaUrl) {
      onErrorCb(new Error("Lambda URL이 설정되지 않았습니다."));
      return;
    }
    
    if (!config.turnSecretKey) {
      log("TURN secret key가 설정되지 않았습니다. STUN만 사용합니다.");
    }

    roomId = id;
    log("P2P 연결 시작, 방 ID: " + roomId);
    
    // ICE 서버 설정을 비동기로 초기화
    config.iceServers = await setupIceServers();
    pc = new RTCPeerConnection({iceServers: config.iceServers});
    
    pc.onicecandidate = function(event) {
      if (event.candidate) {
        const candidateInfo = {
          type: event.candidate.type,
          protocol: event.candidate.protocol,
          address: event.candidate.address,
          port: event.candidate.port,
          candidateType: event.candidate.candidateType
        };
        log("ICE 후보 생성: " + JSON.stringify(candidateInfo));
        sendToServer({
          action: "ice",
          room_id: roomId,
          candidate: event.candidate,
          role: role
        });
      } else {
        log("ICE 후보 수집 완료");
      }
    };

    pc.onicegatheringstatechange = function() {
      log("ICE gathering 상태 변경: " + pc.iceGatheringState);
      
      if (pc.iceGatheringState === "complete") {
        log("ICE 후보 수집 완료 - TURN 후보 포함 여부 확인 중...");

        pc.getStats().then(stats => {
          let relayCandidates = [];
          stats.forEach(report => {
            if (report.type === "local-candidate" && report.candidateType === "relay") {
              relayCandidates.push(report);
            }
          });

          if (relayCandidates.length > 0) {
            log("TURN 서버를 통한 relay 후보 감지됨: " + JSON.stringify(relayCandidates));
          } else {
            log("⚠️ TURN 서버를 통한 relay 후보가 없음! 연결 문제 발생 가능");
          }
        });
      }
    };

    pc.ondatachannel = function(event) {
      log("데이터 채널 수신");
      dataChannel = event.channel;
      setupDataChannel(dataChannel);
    };

    // ICE 연결 상태 로깅 강화
    pc.oniceconnectionstatechange = function() {
      log("ICE 연결 상태 변경: " + pc.iceConnectionState);
      if (pc.iceConnectionState === 'failed') {
        log("ICE 연결 실패 - TURN 서버 연결 문제일 수 있음");
      } else if (pc.iceConnectionState === 'connected') {
        pc.getStats()
          .then(stats => {
            stats.forEach(report => {
              if (report.type === 'candidate-pair' && report.selected) {
                log("선택된 ICE 후보 페어 정보: " + JSON.stringify(report));
              }
            });
          })
          .catch(err => log("Stats 수집 실패: " + err));
      }
    };

    // 연결 상태 로깅 강화
    pc.onconnectionstatechange = function() {
      if (!pc) return;
      
      log("연결 상태 변경: " + pc.connectionState);
      if (pc.connectionState === 'connected') {
        clearTimeout(connectionTimeout);
        log("연결 성공 - 사용 중인 ICE 후보 확인");
        pc.getStats()
          .then(stats => {
            stats.forEach(report => {
              if (report.type === 'transport') {
                log("전송 정보: " + JSON.stringify(report));
              }
            });
          })
          .catch(err => log("Stats 수집 실패: " + err));
      } else if (pc.connectionState === 'failed' || pc.connectionState === 'disconnected') {
        log("연결이 끊어짐");
        onDisconnectedCb();
        Close();
      }
    };
    connectionTimeout = setTimeout(function() {
      log("연결 타임아웃");
      onErrorCb(new Error("Connection timeout"));
      Close();
    }, CONNECTION_TIMEOUT);
    sendToServer({action: "join", room_id: roomId}).then(async function(response) {
      if (response.error) {
        throw new Error(response.error);
      }
      role = response.role;
      log("내 역할: " + role);
      if (response.Item && response.Item.messages) {
        log("Join 응답에서 " + response.Item.messages.length + "개의 메시지 발견");
        const sortedMessages = response.Item.messages.filter(msg => !msg.processed).sort((a, b) => {
          const order = { offer: 0, answer: 1, ice: 2 };
          return order[a.type] - order[b.type];
        });
        for (const msg of sortedMessages) {
          await processMessage(msg);
        }
      }
      if (role === "offerer") {
        log("Offerer로서 데이터 채널 생성");
        dataChannel = pc.createDataChannel("data");
        setupDataChannel(dataChannel);
        try {
          const offer = await pc.createOffer();
          await pc.setLocalDescription(offer);
          await sendToServer({
            action: "offer",
            room_id: roomId,
            sdp: pc.localDescription.sdp,
            role: role
          });
          log("Offer 생성 및 전송 완료");
        } catch (error) {
          log("Offer 생성 중 오류: " + error);
          onErrorCb(error);
        }
      }
      startPolling();
    }).catch(function(error) {
      log("연결 오류: " + error);
      onErrorCb(error);
      Close();
    });
  }

  function Close(intentional = false) {
    if (!disconnected) {
      disconnected = true;
      if (dataChannel) {
        dataChannel.close();
        dataChannel = null;
      }
      if (pc) {
        pc.onconnectionstatechange = null;
        pc.oniceconnectionstatechange = null;
        pc.ondatachannel = null;
        pc.onicecandidate = null;
        
        pc.close();
        pc = null;
      }
      if (pollInterval) {
        clearInterval(pollInterval);
        pollInterval = null;
      }
      if (connectionTimeout) {
        clearTimeout(connectionTimeout);
        connectionTimeout = null;
      }
      remoteDescSet = false;
      iceQueue = [];
      log("연결 종료" + (intentional ? " (사용자 요청)" : ""));
      if (!intentional) {
        onDisconnectedCb();
      }
    }
  }

  function Send(data) {
    if (!dataChannel || dataChannel.readyState !== "open") {
      log("데이터 채널이 열려있지 않음");
      onErrorCb(new Error("Data channel not open"));
      return;
    }
    log("메시지 전송: " + new TextDecoder().decode(data));
    dataChannel.send(data);
  }

  function OnError(callback) { onErrorCb = callback; }
  function OnConnected(callback) { onConnectedCb = callback; }
  function OnMessage(callback) { onMessageCb = callback; }
  function OnDisconnected(callback) { onDisconnectedCb = callback; }

  function Config(options) {
    if (options.lambdaUrl) {
      config.lambdaUrl = options.lambdaUrl;
    }
    if (options.turnSecretKey) {
      config.turnSecretKey = options.turnSecretKey;
    }
    if (options.iceServers) {
      config.iceServers = options.iceServers;
    }
  }  

  return {
    Config: Config,
    Open: Open,
    Close: () => Close(true),
    Send: Send,
    OnError: OnError,
    OnConnected: OnConnected,
    OnMessage: OnMessage,
    OnDisconnected: OnDisconnected
  };
})();

export default p2p;
